// theme.ts
import { extendTheme } from "@chakra-ui/react";

const customTheme = extendTheme({
  breakpoints: {
    base: "0em",
    "sm-1": "calc(30em - 1px)",
    sm: "30em",
    "md-1": "calc(48em - 1px)",
    md: "48em",
    "lg-1": "calc(62em - 1px)",
    lg: "62em",
    "xl-1": "calc(80em - 1px)",
    xl: "80em",
    "2xl-1": "calc(96em - 1px)",
    "2xl": "96em",
  },
  components: {
    Radio: {
      baseStyle: {
        control: {
          borderRadius: "50%", // Circle shape
          _checked: {
            bg: "transparent", // Blue background when checked
            borderColor: "#007FFF",
            padding: "2px",
            _before: {
              content: `""`, // Ensures the inner dot is shown
              display: "block",
              borderRadius: "50%",
              bg: "#007FFF", // Color of the inner dot
              h: "100%",
              w: "100%",
            },
          },
        },
      },
    },
  },
  fonts: {
    heading: "Poppins, sans-serif", // for heading elements
    body: "Poppins, sans-serif", // for body text
  },
  colors: {
    button: {
      500: "#FF1B6D",
    },
  },
  styles: {
    global: {
      body: {
        bg: "#16181F", // setting the background color
        color: "white", // setting the default text color
      },
    },
  },
});

export default customTheme;
